import { Spin } from "antd";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import BackTextComponent from "../../../components/BackTextComponent";
import BottomPageConfirmation from "../../../components/BottomPageConfirmation";
import StepProgressComponent from "../../../components/StepProgressComponent";
import { KeyConditionController } from "./controller";
import "./index.css";
import { KeyConditionActions } from "./model";

function KeyCondition({ match }) {
  const { userGroupUniqueName, userGroupTypeUniqueName, action, conditionId } = match.params;
  const {
    setCurrentStepState,
    stepProgressComponentProps,
    backClick,
    confirmAndClick,
    isNextStepButtonDisabled,
    currentStepState,
    steps,
    loading,
    errorFetchingDetails,
    setDisplayLabels,
  } = KeyConditionController(userGroupUniqueName, userGroupTypeUniqueName, action, conditionId);

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(KeyConditionActions.resetModifiedKeyCondition());
      dispatch(KeyConditionActions.resetSelectedUser());
      dispatch(KeyConditionActions.resetLinkParams());
      dispatch(KeyConditionActions.resetSpecialConditionChecked());
    };
  }, []);

  return (
    <div className="key-condition-container">
      <div className="key-condition-content-container">
        <BackTextComponent
          backText={"Back"}
          clickFunctionality={backClick}
        />
        {errorFetchingDetails ? (
          <div className="error-text">Error Fetching Details</div>
        ) : (
          <Spin spinning={loading}>
            <div className="key-condition-heading">{steps[currentStepState].heading}</div>
            <div className="key-condition-progress">
              <StepProgressComponent {...stepProgressComponentProps} />
            </div>
            {steps[currentStepState].render(
              userGroupUniqueName,
              setCurrentStepState,
              setDisplayLabels,
            )}
          </Spin>
        )}
      </div>
      {steps[currentStepState].isConfirmationRequired === true ? (
        <BottomPageConfirmation
          confirmationText={steps[currentStepState].confirmationText}
          buttonText={steps[currentStepState].confirmationButtonText}
          onClick={() => confirmAndClick()}
          isButtonDisabled={isNextStepButtonDisabled}
          onClickCancel={backClick}
        />
      ) : null}
    </div>
  );
}

export default KeyCondition;
